"use client";

/**
 * Client hook that returns the resolved nav tabs for the current request.
 * Memoised so the navbar doesn't recompute on every keystroke.
 */
import { useMemo } from "react";
import { useFlags, useAudiences } from "@/lib/flags/client";
import { resolveNavTabs, type NavTabDefinition } from "./registry";

export function useNavTabs(): readonly NavTabDefinition[] {
  const flags = useFlags();
  const audiences = useAudiences();
  return useMemo(
    () => resolveNavTabs({ flags, audiences }),
    [flags, audiences]
  );
}
